import { EnvironmentEnum } from '@cpak/adp-cpak-bff-service-models';
import { PlantsEnum } from '@cpak/adp-cpak-quotes-service-models';
import { GoogleIds } from '../../enums/google-ids';

export const GoogleIdsMapping = {
  [PlantsEnum.houston]: {
    [EnvironmentEnum.dev]: GoogleIds.HoustonDevGoogleId,
    [EnvironmentEnum.qa]: GoogleIds.HoustonQAGoogleId,
    [EnvironmentEnum.val]: GoogleIds.HoustonUATGoogleId,
    [EnvironmentEnum.prod]: GoogleIds.HoustonProdGoogleId,
  },
  [PlantsEnum.puurs]: {
    [EnvironmentEnum.dev]: GoogleIds.PuursDevGoogleId,
    [EnvironmentEnum.qa]: GoogleIds.PuursQAGoogleId,
    [EnvironmentEnum.val]: GoogleIds.PuursUATGoogleId,
    [EnvironmentEnum.prod]: GoogleIds.PuursProdGoogleId,
  },
} as const;
